import React, { useRef, useEffect, useState } from "react";
import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "StoreReview";

export default function StoreReview(props) {
  const { storeReviewList, selectedStore, requestReviewList } = props;
  const [loginInfo, setLoginInfo] = useState(null);
  const [isRating, setIsRating] = useState(5);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isReviewModify, setIsReviewModify] = useState(false);
  const [isReviewModifyData, setIsReviewModifyData] = useState(null);
  const { t } = useTranslation();
  const $controller = {
    srUserName: useRef(),
    srReviewText: useRef(), // 리뷰내용
    srReviewPWD: useRef(), // 리뷰 비밀번호
    srPublicYN: useRef(), // 공개여부
  };

  (() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (n) {
          setLoginInfo(n["returnData"][0]);
        }
      }
    );
  })();

  useEffect(() => {
    let userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData) {
      setLoginInfo(userData["returnData"][0]);
    }

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
    };
  }, []);

  useEffect(() => {
    if (loginInfo) {
      $controller.srUserName.current.value = loginInfo.user_nm;
    }
  }, [loginInfo]);

  function ratingHandler(e) {
    let rating = e.target.dataset.rating;
    setIsRating(rating);
  }

  function disabledHandler(val) {
    setIsDisabled(val);
  }

  function addReview() {
    let updateData = {};
    for (let key in $controller) {
      if ($controller[key].current) {
        updateData[key] = $controller[key].current.value
          ? $controller[key].current.value
          : "";
      }
    }
    if (loginInfo !== null) {
      updateData.srUserCompCD = loginInfo.comp_cd;
      updateData.srUserID = loginInfo.user_id;
    }
    updateData.srKey = selectedStore.smKey;
    updateData.srRating = isRating;
    updateData.srCreateDate = new Date();
    updateData.srEditDate = new Date();

    if (checkValidation()) {
      INSERT_STORE_REVIEW(updateData);
    }
  }

  function checkValidation() {
    if ($controller.srUserName.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("storeMall.storeDetail.reviewModal.msg.enterWriter"),
        () => {}
      );
      return false;
    }
    if ($controller.srPublicYN.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("storeMall.storeDetail.reviewModal.msg.checkDisplayYN"),
        () => {}
      );
      return false;
    }
    if (!isDisabled) {
      if ($controller.srReviewPWD.current.value.trim() === "") {
        codeList.Modal.current.alert(
          t("storeMall.storeDetail.reviewModal.msg.enterPW"),
          () => {}
        );
        return false;
      }
    }

    if ($controller.srReviewText.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("storeMall.storeDetail.reviewModal.msg.enterReview"),
        () => {}
      );
      return false;
    }
    return true;
  }

  function INSERT_STORE_REVIEW(updateData) {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/customsStore/review/JS_store_review_insert.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };
    //setLoading(true);
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData.ret) {
          codeList.Modal.current.alert(
            t("storeMall.storeDetail.reviewModal.msg.successInsertReview"),
            () => {}
          );
          requestReviewList(updateData);
          for (let key in $controller) {
            if (key !== "srUserName") {
              $controller[key].current.value = "";
            }
          }
        }
      }
    });
  }

  function modifyReview(reviewData) {
    codeList.Modal.current.confirm(
      t("storeMall.storeDetail.reviewModal.msg.confirmModify"),
      (ret) => {
        if (ret) {
          for (let key in $controller) {
            if (reviewData.hasOwnProperty(key)) {
              $controller[key].current.value = reviewData[key];
            }
          }
          setIsReviewModifyData({
            ...reviewData,
          });
          setIsReviewModify(true);
        }
      }
    );
  }

  function UPDATE_STORE_REVIEW(srShowYN, review) {
    if (!srShowYN) srShowYN = "Y";

    const updateData = {
      srIDX: isReviewModifyData ? isReviewModifyData.srIDX : review.srIDX,
      srReviewText: $controller.srReviewText.current.value,
      srRating: isRating,
      srPublicYN: $controller.srPublicYN.current.value,
      srShowYN: srShowYN,
    };

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/customsStore/review/JS_store_review_update.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };

    codeList.Modal.current.confirm(
      srShowYN === "Y"
        ? t("storeMall.storeDetail.reviewModal.msg.confirmModify")
        : t("storeMall.storeDetail.reviewModal.msg.confirmDelete"),
      (ret) => {
        if (ret) {
          socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
            if (newData) {
              if (newData.ret) {
                codeList.Modal.current.alert(
                  srShowYN === "Y"
                    ? t(
                        "storeMall.storeDetail.reviewModal.msg.successInsertReview"
                      )
                    : t("storeMall.storeDetail.reviewModal.msg.successDelete"),
                  () => {}
                );
                for (let key in $controller) {
                  if (key !== "srUserName") {
                    $controller[key].current.value = "";
                  }
                }
                setIsReviewModify(false);
                setIsReviewModifyData(null);
                requestReviewList(updateData);
              }
            }
          });
        }
      }
    );
  }

  function clearReviewInput() {
    for (let key in $controller) {
      if (key !== "srUserName") {
        $controller[key].current.value = "";
      }
    }
    setIsReviewModify(false);
    setIsReviewModifyData(null);
  }

  return (
    <div
      className="modal fade"
      id="StoreReviewModal"
      tabIndex="-1"
      aria-labelledby="StoreReviewModalLabel"
      aria-hidden="true"
      style={{ backdropFilter: "blur(2px)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content text-dark">
          <div className="modal-header py-2">
            <p
              className="modal-title h6 mb-0 font-weight-bold text-freiscop"
              id="StoreReviewModalLabel"
            >
              {t("storeMall.storeDetail.reviewModal.title")}
            </p>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body container p-0">
            <div className="d-flex  flex-column flex-lg-row justify-content-start">
              <div className="px-3 py-2 border-right" style={{ width: 140 }}>
                <p className="h6 font-weight-bold">
                  {t("storeMall.storeDetail.reviewModal.title")}
                </p>
              </div>
              <div
                className="flex-fill overflow_scroll"
                style={{ minHeight: 280, height: 280 }}
              >
                <div className="d-flex flex-row justify-content-start border-bottom text-dark font-weight-bold">
                  <div className="p-2" style={{ minWidth: 100, maxWidth: 100 }}>
                    {t("storeMall.storeDetail.reviewModal.writer")}
                  </div>
                  <div className="p-2 flex-fill text-dark font-weight-bold">
                    {t("storeMall.storeDetail.reviewModal.contents")}
                  </div>
                  <div className="py-2 pr-2" style={{ width: 150 }}>
                    {t("storeMall.storeDetail.reviewModal.rating")}
                  </div>
                  <div className="py-2 pr-2" style={{ width: 150 }}>
                    {t("storeMall.storeDetail.reviewModal.lastModifyDate")}
                  </div>
                </div>
                {storeReviewList.length > 0 ? (
                  storeReviewList.map((review, index) => {
                    return (
                      <div
                        className="d-flex flex-row justify-content-start border-bottom"
                        key={review.srIDX}
                      >
                        <div
                          className="p-2"
                          style={{ minWidth: 100, maxWidth: 100 }}
                        >
                          <p>{review.srUserName}</p>
                          {loginInfo !== null &&
                            review.srUserID === loginInfo.user_id && (
                              <>
                                <span
                                  className="cursor_pointer font-weight-bold mr-2"
                                  onClick={() => {
                                    modifyReview(review);
                                  }}
                                >
                                  {t(
                                    "storeMall.storeDetail.reviewModal.modify"
                                  )}
                                </span>

                                <span
                                  className="cursor_pointer font-weight-bold text-danger"
                                  onClick={() => {
                                    UPDATE_STORE_REVIEW("N", review);
                                  }}
                                >
                                  {t(
                                    "storeMall.storeDetail.reviewModal.delete"
                                  )}
                                </span>
                              </>
                            )}
                        </div>
                        <p className="p-2 flex-fill text-dark font-weight-bold">
                          {review.isShow
                            ? review.srReviewText
                            : t(
                                "storeMall.storeDetail.reviewModal.privateReview"
                              )}
                        </p>
                        <div className="py-2 pr-2" style={{ width: 150 }}>
                          <i className="icon-star text-warning" />
                          {review.srRating}
                        </div>
                        <div className="py-2 pr-2" style={{ width: 150 }}>
                          {review.srEditDate}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    className="m-2 p-3 rounded bg-light d-flex flex-row justify-content-center align-items-center"
                    style={{ height: 228 }}
                  >
                    <p className="font-weight-bold">
                      {t("storeMall.storeDetail.reviewModal.msg.noReview")}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="border-top">
              <div className="d-flex flex-column flex-lg-row justify-content-start">
                <div className="px-3 py-2 border-right" style={{ width: 140 }}>
                  <p className="h6 mb-0 font-weight-bold">
                    {t("storeMall.storeDetail.reviewModal.writeReview")}
                  </p>
                </div>
                <div className="flex-fill p-2">
                  <div className="row m-0 p-0 pb-2">
                    <div className="m-0 px-1 col-12 d-flex flex-row justify-content-between align-items-center">
                      <div>
                        <span className="h6 p-0 m-0 mr-1">
                          {t("storeMall.storeDetail.reviewModal.rating")}
                        </span>
                        <span className="h6 p-0 m-0">
                          {isRating >= 1 ? (
                            <i
                              className="icon-star text-warning cursor_pointer"
                              data-rating={1}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          ) : (
                            <i
                              className="icon-star-empty text-warning cursor_pointer"
                              data-rating={1}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          )}
                          {isRating >= 2 ? (
                            <i
                              className="icon-star text-warning cursor_pointer"
                              data-rating={2}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          ) : (
                            <i
                              className="icon-star-empty text-warning cursor_pointer"
                              data-rating={2}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          )}
                          {isRating >= 3 ? (
                            <i
                              className="icon-star text-warning cursor_pointer"
                              data-rating={3}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          ) : (
                            <i
                              className="icon-star-empty text-warning cursor_pointer"
                              data-rating={3}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          )}
                          {isRating >= 4 ? (
                            <i
                              className="icon-star text-warning cursor_pointer"
                              data-rating={4}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          ) : (
                            <i
                              className="icon-star-empty text-warning cursor_pointer"
                              data-rating={4}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          )}
                          {isRating >= 5 ? (
                            <i
                              className="icon-star text-warning cursor_pointer"
                              data-rating={5}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          ) : (
                            <i
                              className="icon-star-empty text-warning cursor_pointer"
                              data-rating={5}
                              onClick={(e) => {
                                ratingHandler(e);
                              }}
                            />
                          )}
                        </span>
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary font-size-09 mr-1"
                        onClick={clearReviewInput}
                      >
                        {t("storeMall.storeDetail.reviewModal.reset")}
                      </button>
                    </div>
                  </div>
                  <div className="row m-0 p-0 pb-2 pr-1">
                    <div className="m-0 px-1 col-5">
                      <input
                        className="form-control px-1 py-0 font-size-09"
                        type="text"
                        placeholder={t(
                          "storeMall.storeDetail.reviewModal.writer"
                        )}
                        ref={$controller.srUserName}
                      />
                    </div>
                    <div className="m-0 px-1 col-5">
                      <input
                        className="form-control px-1 py-0 font-size-09"
                        type="text"
                        placeholder={t(
                          "storeMall.storeDetail.reviewModal.password"
                        )}
                        ref={$controller.srReviewPWD}
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="m-0 px-1 col-2">
                      <select
                        className="form-control px-1 py-0 font-size-09"
                        ref={$controller.srPublicYN}
                        onChange={(e) => {
                          disabledHandler(e.target.value !== "N");
                        }}
                      >
                        <option value="">
                          {t("storeMall.storeDetail.reviewModal.publicYN")}
                        </option>
                        <option value="Y">
                          {t("storeMall.storeDetail.reviewModal.public")}
                        </option>
                        <option value="N">
                          {t("storeMall.storeDetail.reviewModal.private")}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="row m-0 p-0 pb-2 pr-1">
                    <div className="m-0 px-1 col-12">
                      <textarea
                        ref={$controller.srReviewText}
                        className="form-control font-size-09"
                        rows="5"
                        placeholder={t(
                          "storeMall.storeDetail.reviewModal.msg.enterReview"
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer py-2">
            <button
              type="button"
              className="btn btn-sm btn-info font-size-09"
              onClick={() => {
                if (isReviewModify) {
                  UPDATE_STORE_REVIEW("Y");
                } else {
                  addReview();
                }
              }}
            >
              {isReviewModify
                ? t("storeMall.storeDetail.reviewModal.modify")
                : t("storeMall.storeDetail.reviewModal.submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
